angular.module('unica_survey.survey_controllers', [])

.controller('SurveyBasicController',
	function(
		$rootScope, $scope
	) {

	$scope.forms = {};

	$scope.changeSurveyAvatar = function() {
		$rootScope.surveyData.avatar_changed = true;
	};

});